import { FormattedMessage } from 'react-intl';

import { ConfigStepBody } from './config-step';
import { fieldsTranslations, messages } from './messages';
import { actionMap, initialState } from './reducer';
import { TotesConfigStepFooter } from './totes-config-step-footer';
import { ImportType } from '../../../../../components/csv-import/data/types/import-type';
import { StepType } from '../../../../../components/csv-import/data/types/step-type';
import { ImportProvider } from '../../../../../components/csv-import/ui/components/import-context';
import { SingleImportDrawer } from '../../../../../components/csv-import/ui/components/single-import-drawer/single-import-drawer';
import { CreateMappingStepBody } from '../../../../../components/csv-import/ui/components/steps/create-mapping-step/create-mapping-step';
import { CreateMappingStepFooter } from '../../../../../components/csv-import/ui/components/steps/create-mapping-step/create-mapping-step-footer';
import {
  ImportIsProcessingStepBody,
  ImportIsProcessingStepFooter,
} from '../../../../../components/csv-import/ui/components/steps/import-is-processing-step/import-is-processing-step';
import { getTranslationFn } from '../../../../../components/csv-import/ui/utils';
import { CSV_TOTE_IMPORT_JOB_COMPLETE } from '../../../../../services/pusher-service/pusher-contract-messages';
import { Workflows } from '../../../../../tracking/tracking-constants';
import { WorkflowSteps } from '../../../../../tracking/use-workflow-tracking';

const steps = [
  {
    id: StepType.CREATE_CONFIG,
    title: <FormattedMessage {...messages.createConfigStep} />,
    body: <ConfigStepBody />,
    footer: <TotesConfigStepFooter />,
  },
  {
    id: StepType.CREATE_MAPPING,
    title: <FormattedMessage {...messages.createMappingStep} />,
    body: <CreateMappingStepBody />,
    footer: <CreateMappingStepFooter />,
  },
  {
    id: StepType.IMPORT_IS_PROCESSING,
    title: <FormattedMessage {...messages.importResult} />,
    body: (
      <ImportIsProcessingStepBody
        successMessage={<FormattedMessage {...messages.importResultSuccess} />}
        title={<FormattedMessage {...messages.importResult} />}
      />
    ),
    footer: <ImportIsProcessingStepFooter />,
  },
];

const translateField = getTranslationFn(fieldsTranslations, ImportType.tote);

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @param {() => void} props.onSuccess
 * @param {(step: string, params: object) => void} props.trackProcess
 * @param {string} [props.inventoryWarehouseId] - Optional pre-selected warehouse ID
 * @returns {React.JSX.Element}
 */
export const TotesImportDrawer = ({ onClose, onSuccess, trackProcess, inventoryWarehouseId }) => {
  const createCustomImportSettings = (form) => {
    return {
      inventoryWarehouseId: form.inventoryWarehouse,
    };
  };

  const onCancel = (step) => {
    return () => {
      onClose();
      trackProcess(WorkflowSteps.CANCEL, { step });
    };
  };

  const init = (initState) => {
    return {
      ...initState,
      inventoryWarehouse: inventoryWarehouseId,
    };
  };

  return (
    <ImportProvider
      actionMap={actionMap}
      createCustomImportSettings={createCustomImportSettings}
      importType={ImportType.tote}
      init={init}
      initialState={initialState}
      onClose={onCancel(StepType.IMPORT_IS_PROCESSING)}
      onComplete={onSuccess}
      pusherEvent={CSV_TOTE_IMPORT_JOB_COMPLETE}
      trackProcess={trackProcess}
      translateField={translateField}
      workflowType={Workflows.CSV_TOTE_IMPORT_FLOW}
    >
      <SingleImportDrawer header={<FormattedMessage {...messages.header} />} onCancel={onCancel} steps={steps} />
    </ImportProvider>
  );
};
